/* eslint-disable no-alert */
import React, { useContext, useEffect, useState } from 'react';

import JobListContext from '../../context/jobListContext';
import Filterbutton from '../../../components/filterDeleteButton';

import { FilterListCtn } from './index.style';
import filter from "../../../components/filterDeleteButton/filter";

const FiltersRm: React.FC<any> = (): React.ReactElement => {
  const { filtersReactive, filtersPlanned } = useContext(JobListContext);

  const [periodFilter, setPeriodFilter] = useState(() => {
    if(filtersReactive.periodFilter != '') return <Filterbutton filterCategory="periodFilter" filter={filtersReactive.periodFilter} />;
  });

  const [plannedPeriodFilter, setPlannedPeriodFilter ] = useState(() => {
      if(filtersPlanned.periodFilter != '') return <Filterbutton filterCategory='plannedPeriodFilter' filter={filtersPlanned.periodFilter}/>
    }
  );

  const [slaArray, setSlaArray] = useState(
    () => {
      if(filtersReactive.slaFilters != '') return <Filterbutton key={filtersReactive.slaFilters} filterCategory="slaFilters" filter={filtersReactive.slaFilters} />
      return;
    }
  );
  const [priortiyFiltersArray, setPriortiyFiltersArray] = useState(() => {
    if (filtersReactive.priortiyFilters != '') return <Filterbutton key={filtersReactive.priortiyFilters} filterCategory="priorityFilters" filter={filtersReactive.priortiyFilters} />
    return;
  }
  );
  const [statusFiltersArray, setStatusFiltersArray] = useState(() => {
    if(filtersReactive.statusFilters != '') return <Filterbutton key={filtersReactive.statusFilters} filterCategory="statusFilters" filter={filtersReactive.statusFilters} />
    return;
  }
  );

  const [maintenanceTypeFiltersArray, setMaintenanceTypeFiltersArray] = useState(
    () => {
      if(filtersPlanned.maintenanceFilter != '') return <Filterbutton key={filtersPlanned.maintenanceFilter} filterCategory="maintenanceFilters" filter={filtersPlanned.maintenanceFilter} />
      return;
    }
  );

  const [plannedStatusFiltersArray, setPlannedStatusFiltersArray] = useState(
    () => {
      if(filtersPlanned.statusFilter != '') return <Filterbutton key={filtersPlanned.statusFilter} filterCategory="plannedStatusFilters" filter={filtersPlanned.statusFilter} />
      return;
    }
  );

  const [actionTypeFiltersArray, setActionTypeFiltersArray] = useState(() => {
    return filtersReactive.actionFilters.map(filter =>
      <Filterbutton key={filter} filterCategory='actionFilter' filter={filter}/>
    );
  }
  );

  const makeDateFilters =(type: string) => {
    let chosenFilter;
    let filtercategory;
    if(type == 'reactive') {
      chosenFilter = filtersReactive;
      filtercategory = 'dateFilter';
    } else if(type == 'planned') {
      chosenFilter = filtersPlanned;
      filtercategory = 'plannedDateFilter'
    }
    
    if (chosenFilter.dateFilter != undefined && Object.keys(chosenFilter.dateFilter).length) {
      return <Filterbutton key={chosenFilter.dateFilter} filterCategory={filtercategory}
                           filter={chosenFilter.dateFilter}
                           datePeriod={chosenFilter.dateFilter.startDate.format('DD/MM/YYYY') + ' to ' + chosenFilter.dateFilter.endDate.format('DD/MM/YYYY')}/>;
    } else {
      return [];
    }

  };

  const [ listedReactivePeriodArray, setReactivePeriodFiltersArray ] = useState (() => {
    return makeDateFilters('reactive');
  });

  const [ plannedPeriodArray, setPlannedPeriodArray ] = useState( () => {
    return makeDateFilters('planned');
  });

  useEffect(() => {
    setPeriodFilter( prevState => {
      if(filtersReactive.periodFilter != '') return <Filterbutton filterCategory="periodFilter" filter={filtersReactive.periodFilter} />;
    });

    setPlannedPeriodFilter( prevState => {
      if(filtersPlanned.periodFilter != '') return <Filterbutton filterCategory='plannedPeriodFilter' filter={filtersPlanned.periodFilter}/>
      }
    );

    setSlaArray(prevState => {
      if(filtersReactive.slaFilters != '') return <Filterbutton key={filtersReactive.slaFilters} filterCategory="slaFilters" filter={filtersReactive.slaFilters} />
    });
    setPriortiyFiltersArray(prevState => {
      if (filtersReactive.priortiyFilters != '') return <Filterbutton key={filtersReactive.priortiyFilters} filterCategory="priorityFilters" filter={filtersReactive.priortiyFilters} />
    });
    setStatusFiltersArray( prevState => {
        if(filtersReactive.statusFilters != '') return <Filterbutton key={filtersReactive.statusFilters} filterCategory="statusFilters" filter={filtersReactive.statusFilters} />
      }
    );

    setMaintenanceTypeFiltersArray( prevState => {
       if(filtersPlanned.maintenanceFilter != '') return <Filterbutton key={filtersPlanned.maintenanceFilter} filterCategory="maintenanceFilters" filter={filtersPlanned.maintenanceFilter} />
      }
    );

    setPlannedStatusFiltersArray( prevState => {
        if(filtersPlanned.statusFilter != '') return <Filterbutton key={filtersPlanned.statusFilter} filterCategory="plannedStatusFilters" filter={filtersPlanned.statusFilter} />
      }
    );

    setActionTypeFiltersArray(
      filtersReactive.actionFilters.map(filter => (
        <Filterbutton key={filter} filterCategory='actionFilter' filter={filter}/>
      ))
    );

    setReactivePeriodFiltersArray( () => {return makeDateFilters('reactive')});

    setPlannedPeriodArray(() => {return makeDateFilters('planned')});
  }, [filtersReactive, filtersPlanned]);

  return (
    <FilterListCtn>
      {periodFilter}
      {plannedPeriodFilter}
      {slaArray}
      {priortiyFiltersArray}
      {statusFiltersArray}
      {maintenanceTypeFiltersArray}
      {plannedStatusFiltersArray}
      {listedReactivePeriodArray}
      {plannedPeriodArray}
      {actionTypeFiltersArray}
    </FilterListCtn>
  );
};

export default FiltersRm;
